import { TabObject } from './tab-object.model';

export class TabIndexObject {

    constructor(public index: number, public tab: TabObject) {
    }
}